// NOTE: This component wraps the Drawer component and handles the generic
// header and footer content shared among all reports.
import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import {
  Button,
  Divider,
  Drawer,
} from '@makeably/creativex-design-system';
import styles from './ReportingDrawer.module.css';

const propTypes = {
  children: PropTypes.node.isRequired,
  header: PropTypes.string.isRequired,
  isApplyDisabled: PropTypes.bool.isRequired,
  isOpen: PropTypes.bool.isRequired,
  onApply: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  subheader: PropTypes.string.isRequired,
};

function ReportingDrawer({
  children,
  header,
  isApplyDisabled,
  isOpen,
  onApply,
  onClose,
  subheader,
}) {
  const drawerClasses = classNames(styles.drawer, { [styles.hidden]: !isOpen });

  return (
    <Drawer isOpen={isOpen} onClose={onClose}>
      <div className={drawerClasses}>
        <div className={`u-scrollShadowBottom ${styles.scrollable}`}>
          <div className={styles.header}>
            <h5>{ header }</h5>
            <div className="t-body-2">{ subheader }</div>
          </div>
          <Divider />
          <div className={styles.body}>
            { children }
          </div>
        </div>
        <div className={styles.footer}>
          <div className="u-buttonGroup">
            <Button
              label="Cancel"
              variant="tertiary"
              onClick={onClose}
            />
            <Button
              disabled={isApplyDisabled}
              label="Apply"
              variant="primary"
              onClick={onApply}
            />
          </div>
        </div>
      </div>
    </Drawer>
  );
}

ReportingDrawer.propTypes = propTypes;

export default ReportingDrawer;
